import { CommonModule } from '@angular/common';
import { Component, inject, OnInit, QueryList, ViewChildren } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatSelectModule } from '@angular/material/select';
import { BaseChartDirective } from 'ng2-charts';
import { ChartData, ChartEvent, ChartType, ChartConfiguration } from 'chart.js';
import { HttpClient } from '@angular/common/http';
import { Api } from '../../services/api';
import { AlertService } from '../../services/alert.service';
import { MdlSelectCompanyType } from '../../components/mdl-public-private/mdl-public-private';
import { MdlmanageContract } from '../../components/mdl-manage-contract/mdl-manage-contract';
import { MdlNewTaskComponent } from '../../components/mdl-new-task/mdl-new-task';
import { forkJoin } from 'rxjs';
import { Router } from '@angular/router';
import { jwtDecode } from 'jwt-decode';
import { Chart } from 'chart.js';
import { ViewChild, AfterViewInit } from '@angular/core';
import { MontoInteligentePipe } from '../../services/montoInteligente.pipe';



@Component({
  selector: 'app-main-page',
  standalone: true,
  imports: [
    CommonModule,
    MatSelectModule,
    MatButtonModule,
    MatDividerModule,
    FormsModule,
    MatDialogModule,
    BaseChartDirective,
    MontoInteligentePipe
  ],
  templateUrl: './main-page.html',
  styleUrls: ['./main-page.css'],
})
export class MainPage implements AfterViewInit, OnInit {
    @ViewChildren(BaseChartDirective) charts!: QueryList<BaseChartDirective>;

  tareas: any[] = [];
  oportunidades: any[] = [];
  oportunidadesSinAvance: any[] = [];
  contratos: any[] = [];
  contratosProximos: any[] = [];
  cuentasContactos: any[] = [];

  

  userRole: string = '';
  isLoading = true;
  errorMessage = '';
  openSection: string | null = 'dia';

  tareasDelDia: any[] = [];
  tareasProximas: any[] = [];
  tareasVencidas: any[] = [];
   notifications : any[]=[];
  readonly dialog = inject(MatDialog);

  totalOportunidadesEnCurso: number = 0;
  oportunidadesCerradas: number = 0;
  metasDelMes: number = 0;
  cumplimientoMetas: number = 0;
  tareasCompletadas: number = 0;
  totalTareas: number = 0;

  ngOnInit(): void {
    this.getUserRoleFromToken();

    if (this.userRole === 'Administrador' || this.userRole === 'admin') {
      this.loadAdminDashboard();
    } else if (this.userRole === 'Ejecutivo') {
      this.loadEjecutivoDashboard();
    } else {
      console.warn('⚠️ Rol no reconocido, cargando por defecto como admin.');
      this.loadAdminDashboard();
    }

    this.cargarTareasUsuario();
    this.cargarOportunidades();
    this.cargarContratos();
    this.cargarCuentasYContactos();
    this.loadNotifications();
  }

  constructor(
    private api: Api,
    private router: Router,
    private alertService: AlertService
  ) {}

  getUserRoleFromToken() {
    const token = localStorage.getItem('crmtoken');
    if (token) {
      try {
        const decoded: any = jwtDecode(token);
        this.userRole = decoded.roleName;
        console.log('Rol detectado:', this.userRole);
      } catch (error) {
        console.error('Error al decodificar token:', error);
      }
    }
  }

  reload() {
    if (this.userRole === 'Administrador' || this.userRole === 'admin') {
      this.loadAdminDashboard();
    } else {
      this.loadEjecutivoDashboard();
    }
  }

  loadAdminDashboard() {
    this.loadResumenGeneral();
    this.loadTendenciaAnual();
    this.loadTopCuentas();
    this.loadTopEjecutivos();
    this.loadAvanceMensual();
  }

  

  loadEjecutivoDashboard() {
    this.loadEjecutivoResumen();

    this.api.getEjecutivoTendencia().subscribe({
      next: (res: any) => {
        this.annualLine.data = res;
        this.annualLine.options = {
          responsive: true,
          maintainAspectRatio: false,
          plugins: {
            legend: {
              display: true,
              position: 'top',
              labels: {
                color: '#333',
                font: { size: 13 },
                usePointStyle: true,
                pointStyle: 'line',
              },
            },
          },
          scales: {
            x: { grid: { display: false } },
            y: { beginAtZero: true },
          },
        };
        setTimeout(() => this.refreshAllCharts(), 400);

      },
      
    });

    // Top cuentas (barras horizontales)
    this.api.getEjecutivoCuentas().subscribe({
      next: (res: any) => {
        this.topAccounts.data = res;
        this.topAccounts.options = {
          responsive: true,
          maintainAspectRatio: false,
          indexAxis: 'y',
          plugins: {
            legend: {
              display: true,
              position: 'bottom',
              labels: {
                color: '#333',
                font: { size: 12 },
                usePointStyle: true,
                pointStyle: 'circle',
              },
            },
          },
          scales: {
            x: { beginAtZero: true, grid: { display: false } },
            y: { grid: { display: false } },
          },
        };
        setTimeout(() => this.refreshAllCharts(), 400);

      },
    });

    // Avance mensual (barras o líneas)
    this.api.getEjecutivoVentas().subscribe({
      next: (res: any) => {
        this.monthlyLine.data = res;
        this.monthlyLine.options = {
          responsive: true,
          maintainAspectRatio: false,
          plugins: {
            legend: {
              display: true,
              position: 'bottom',
              labels: {
                color: '#333',
                font: { size: 12 },
                usePointStyle: true,
                pointStyle: 'circle',
              },
            },
          },
          scales: {
            x: { grid: { display: false } },
            y: { beginAtZero: true },
          },
        };
        setTimeout(() => this.refreshAllCharts(), 400);

      },
    });

    this.api.getEjecutivoAvance().subscribe({
      next: (res: any) => {
        this.taskProgress.data = res;
        this.taskProgress.options = {
          responsive: true,
          maintainAspectRatio: false,
          cutout: '60%',
          plugins: {
            legend: {
              display: true,
              position: 'bottom',
              labels: {
                color: '#333',
                font: { size: 12 },
                usePointStyle: true,
                pointStyle: 'circle',
              },
            },
          },
        };
       setTimeout(() => this.refreshAllCharts(), 400);

      },
    });
  }

  annualLine: {
    data: ChartData<'line'>;
    options: ChartConfiguration<'line'>['options'];
  } = { data: { labels: [], datasets: [] }, options: {} };
  execBar: {
    data: ChartData<'bar'>;
    options: ChartConfiguration<'bar'>['options'];
  } = { data: { labels: [], datasets: [] }, options: {} };
  topAccounts: {
    data: ChartData<'bar'>;
    options: ChartConfiguration<'bar'>['options'];
  } = { data: { labels: [], datasets: [] }, options: {} };
  monthlyLine: {
    data: ChartData<'line'>;
    options: ChartConfiguration<'line'>['options'];
  } = { data: { labels: [], datasets: [] }, options: {} };
  taskProgress: {
    data: ChartData<'doughnut'>;
    options: ChartConfiguration<'doughnut'>['options'];
  } = { data: { labels: [], datasets: [] }, options: {} };

  showDayTasks = true;
  showNextTasks = true;
  showLateTasks = true;

  loadResumenGeneral() {
    this.api.getResumenGeneral().subscribe({
      next: (res: any) => {
        this.totalOportunidadesEnCurso = res.oportunidadesEnCurso ?? 0;
        this.oportunidadesCerradas = res.oportunidadesCerradas ?? 0;
        this.metasDelMes = res.metasMes ?? 0;
        this.cumplimientoMetas = res.cumplimientoMetas ?? 0;
        this.tareasCompletadas = res.tareasCompletadas ?? 0;
      },
      error: (err) => {
        console.error('Error cargando resumen general:', err);
      },
    });
  }

  loadEjecutivoResumen() {
    this.api.getEjecutivoResumen().subscribe({
      next: (res: any) => {
        this.totalOportunidadesEnCurso = res.oportunidadesEnCurso ?? 0;
        this.oportunidadesCerradas = res.oportunidadesCerradas ?? 0;
        this.metasDelMes = res.metasMes ?? 0;
        this.cumplimientoMetas = res.cumplimientoMetas ?? 0;
        this.tareasCompletadas = res.tareasCompletadas ?? 0;
        this.totalTareas = res.totalTareas ?? 0;
      },
      error: (err) => {
        console.error('Error cargando resumen ejecutivo:', err);
      },
    });
  }


  loadTendenciaAnual() {
    this.api.getTendenciaAnual().subscribe({
      next: (res) => {
        console.log('Datos de tendencia anual:', res);
        const data = res as { labels: string[]; datasets: any[] };
        console.log('Labels:', data.labels);
        console.log('Datasets:', data.datasets);

        this.annualLine.data = { labels: data.labels, datasets: data.datasets };

        this.annualLine.options = {
          responsive: true,
          maintainAspectRatio: false,
          layout: { padding: 10 },
          plugins: {
            legend: {
              display: true,
              position: 'bottom',
              align: 'start',
              labels: {
                usePointStyle: true,
                pointStyle: 'circle',
                padding: 20,
                font: { size: 12 },
              },
            },
            tooltip: {
              backgroundColor: 'rgba(0,0,0,0.7)',
              titleColor: '#fff',
              bodyColor: '#fff',
              callbacks: {
                label: (context) => {
                  const value = context.parsed.y;
                  if (value >= 1000000)
                    return `Avance: ${(value / 1000000).toFixed(1)}M`;
                  if (value >= 1000)
                    return `Avance: ${(value / 1000).toFixed(1)}K`;
                  return `Avance: ${value}`;
                },
              },
            },
          },
          elements: {
            point: { radius: 4, hoverRadius: 6 },
            line: { tension: 0.4, borderWidth: 2 },
          },
          scales: {
            x: {
              grid: { display: false },
              ticks: {
                font: { size: 11 },
                maxRotation: 0,
                minRotation: 0,
              },
            },
            y: {
              beginAtZero: true,
              ticks: {
                callback: (value: string | number) => {
                  const num = Number(value);
                  if (num >= 1000000) return `${num / 1000000}M`;
                  if (num >= 1000) return `${num / 1000}K`;
                  return value;
                },
                font: { size: 11 },
              },
              grid: {
                color: 'rgba(0, 0, 0, 0.1)',
              },
            },
          },
        };
      setTimeout(() => this.refreshAllCharts(), 300);

      },  
      error: (err) => console.error('Error cargando tendencia anual:', err),
    });
  }

private refreshAllCharts() {
  this.charts?.forEach((chart) => {
    chart.chart?.resize();
    chart.update();
  });
}

ngAfterViewInit() {
  window.addEventListener('resize', () => this.refreshAllCharts());
}


  loadTopCuentas() {
    this.api.getTopCuentas().subscribe({
      next: (res) => {
        const data = res as { labels: string[]; datasets: any[] };
        this.topAccounts.data = {
          labels: data.labels,
          datasets: data.datasets,
        };
        this.topAccounts.options = {
          responsive: true,
          maintainAspectRatio: false,
          indexAxis: 'y',
          layout: { padding: 10 },
          plugins: {
            legend: {
              display: true,
              position: 'bottom',
              align: 'start',
              labels: {
                usePointStyle: true,
                pointStyle: 'circle',
                padding: 20,
                font: { size: 12 },
              },
            },
            tooltip: {
              backgroundColor: 'rgba(0,0,0,0.7)',
              titleColor: '#fff',
              bodyColor: '#fff',
            },
          },
          elements: {
            point: { radius: 4, hoverRadius: 6 },
            line: { tension: 0.4, borderWidth: 2 },
          },
        };
      setTimeout(() => this.refreshAllCharts(), 100);

      },
      error: (err) => console.error('Error cargando top cuentas:', err),
    });
  }

  loadTopEjecutivos() {
    this.api.getTopEjecutivos().subscribe({
      next: (res) => {
        const data = res as { labels: string[]; datasets: any[] };

        this.execBar.data = { labels: data.labels, datasets: data.datasets };
        this.execBar.options = {
          responsive: true,
          maintainAspectRatio: false,
          indexAxis: 'y',
          layout: { padding: 10 },
          plugins: {
            legend: {
              display: true,
              position: 'bottom',
              align: 'start',
              labels: {
                usePointStyle: true,
                pointStyle: 'circle',
                padding: 20,
                font: { size: 12 },
              },
            },
            tooltip: {
              backgroundColor: 'rgba(0,0,0,0.7)',
              titleColor: '#fff',
              bodyColor: '#fff',
            },
          },
          elements: {
            point: { radius: 4, hoverRadius: 6 },
            line: { tension: 0.4, borderWidth: 2 },
          },
        };
      setTimeout(() => this.refreshAllCharts(), 100);

      },
      error: (err) => console.error('Error cargando top ejecutivos:', err),
    });
  }

  loadAvanceMensual() {
    this.api.getAvanceMensual().subscribe({
      next: (res) => {
        const data = res as { labels: string[]; datasets: any[] };

        this.monthlyLine.data = {
          labels: data.labels,
          datasets: data.datasets,
        };

        this.monthlyLine.options = {
          responsive: true,
          maintainAspectRatio: false,
          layout: { padding: 10 },
          plugins: {
            legend: {
              display: true,
              position: 'bottom',
              align: 'start',
              labels: {
                usePointStyle: true,
                pointStyle: 'circle',
                padding: 20,
                font: { size: 12 },
              },
            },
            tooltip: {
              backgroundColor: 'rgba(0,0,0,0.7)',
              titleColor: '#fff',
              bodyColor: '#fff',
              callbacks: {
                // 👇 Tooltip con formato M o K
                label: (context) => {
                  const value = Number(context.parsed.y);
                  if (value >= 1000000)
                    return `Avance: ${(value / 1000000).toFixed(1)}M`;
                  if (value >= 1000)
                    return `Avance: ${(value / 1000).toFixed(1)}K`;
                  return `Avance: ${value}`;
                },
              },
            },
          },
          elements: {
            point: { radius: 4, hoverRadius: 6 },
            line: { tension: 0.4, borderWidth: 2 },
          },
          scales: {
            x: {
              grid: { display: false },
              ticks: {
                font: { size: 11 },
                maxRotation: 0,
                minRotation: 0,
              },
            },
            y: {
              beginAtZero: true,
              ticks: {
                callback: (value: string | number) => {
                  const num = Number(value);
                  if (num >= 1000000) return `${(num / 1000000).toFixed(0)}M`;
                  if (num >= 1000) return `${(num / 1000).toFixed(0)}K`;
                  return num;
                },
                font: { size: 11 },
              },
              grid: { color: 'rgba(0,0,0,0.1)' },
            },
          },
        };
        setTimeout(() => this.refreshAllCharts(), 100);
      },
      error: (err) => console.error('Error cargando avance mensual:', err),
    });
  }

  cargarTareasUsuario() {
    this.api.getTaskByUser({}).subscribe({
      next: (response: any) => {
        console.log('📦 Tareas recibidas:', response);
  
        if (response.tareas && Array.isArray(response.tareas)) {
          const tareas = response.tareas;
  
          const hoy = new Date().toISOString().split('T')[0];
  
          const fechaStr = (f: any) =>
            f ? new Date(f).toISOString().split('T')[0] : '';
  
          const esActiva = (t: any) => {
            const estado = (t.estado || '').toLowerCase();
            return (
              estado !== 'completada' &&
              estado !== 'realizada' &&
              estado !== 'cancelada'
            );
          };
  
          const tareasActivas = tareas.filter(esActiva);
  
          this.tareasDelDia = tareasActivas.filter(
            (t: any) => fechaStr(t.fecha_vencimiento) === hoy
          );
          this.tareasProximas = tareasActivas.filter(
            (t: any) => fechaStr(t.fecha_vencimiento) > hoy
          );
          this.tareasVencidas = tareasActivas.filter(
            (t: any) => fechaStr(t.fecha_vencimiento) < hoy
          );
        }
      },
      error: (err) => {
        console.error('Error al obtener tareas:', err);
      },
    });
  }
  

  cargarOportunidades() {
    this.isLoading = true;

    this.api.getOportunidadesByUser().subscribe({
      next: (res: any) => {
        this.oportunidades = res.oportunidades || [];

        const todas = res.oportunidades || [];
        const hoy = new Date();
        const limite = 15;

        this.oportunidadesSinAvance = todas
          .filter((o: any) => {
            const fecha = new Date(o.fecha_sgte_paso || o.fecha_creacion);
            const diasSinAvance =
              (hoy.getTime() - fecha.getTime()) / (1000 * 60 * 60 * 24);
            return diasSinAvance >= limite;
          })
          .map((o: any) => ({
            ...o,
            diasSinAvance: Math.floor(
              (hoy.getTime() -
                new Date(o.fecha_sgte_paso || o.fecha_creacion).getTime()) /
                (1000 * 60 * 60 * 24)
            ),
          }));
        this.isLoading = false;
      },
      error: (err) => {
        console.error('Error al cargar oportunidades:', err);
        this.errorMessage = 'No se pudieron cargar las oportunidades';
        this.isLoading = false;
      },
    });
  }

  cargarContratos() {
    this.isLoading = true;

    this.api.getContratosByUser().subscribe({
      next: (res: any) => {
        console.log('📦 Contratos recibidos:', res.contratos);

        const todos = res.contratos || [];
        const hoy = new Date();
        const limiteDias = 400;

        this.contratosProximos = todos.filter((c: any) => {
          if (!c.fecha_expiracion) return false;
          const fechaExp = new Date(c.fecha_expiracion);
          const diasRestantes = Math.floor(
            (fechaExp.getTime() - hoy.getTime()) / (1000 * 60 * 60 * 24)
          );
          return diasRestantes >= 0 && diasRestantes <= limiteDias;
        });

        this.contratos = todos;

        this.isLoading = false;
      },
      error: (err) => {
        console.error('Error al cargar contratos:', err);
        this.errorMessage = 'No se pudieron cargar los contratos';
        this.isLoading = false;
      },
    });
  }

  cargarCuentasYContactos() {
    this.isLoading = true;
    const LIMITE_DIAS_SIN_INTERACCION = 30;

    forkJoin({
      cuentas: this.api.getCuentasByUser(),
      contactos: this.api.getContactosByUser(),
    }).subscribe({
      next: (res: any) => {
        const hoy = new Date();

        const cuentas = (res.cuentas?.cuentas || [])
          .filter((c: any) => {
            const fecha = new Date(c.fecha_actualizacion || c.fecha_creacion);
            const dias =
              (hoy.getTime() - fecha.getTime()) / (1000 * 60 * 60 * 24);
            return dias >= LIMITE_DIAS_SIN_INTERACCION;
          })
          .map((c: any) => ({
            tipo: 'cuenta',
            id: c.cuenta_id,
            nombre: c.nombre_empresa,
            creadoPor: c.ejecutivo,
            fecha: c.fecha_actualizacion || c.fecha_creacion,
          }));

        const contactos = (res.contactos?.contactos || [])
          .filter((ct: any) => {
            const fecha = new Date(ct.fecha_actualizacion || ct.fecha_creacion);
            const dias =
              (hoy.getTime() - fecha.getTime()) / (1000 * 60 * 60 * 24);
            return dias >= LIMITE_DIAS_SIN_INTERACCION;
          })
          .map((ct: any) => ({
            tipo: 'contacto',
            id: ct.contacto_id,
            nombre: `${ct.nombre} ${ct.apellido}`,
            creadoPor: ct.cuenta?.ejecutivo,
            fecha: ct.fecha_actualizacion || ct.fecha_creacion,
          }));

        this.cuentasContactos = [...cuentas, ...contactos].sort(
          (a, b) => new Date(b.fecha).getTime() - new Date(a.fecha).getTime()
        );

        console.log('Resultados sin interacción:', this.cuentasContactos);
        this.isLoading = false;
      },
      error: (err) => {
        console.error('Error al cargar cuentas/contactos:', err);
        this.errorMessage = 'No se pudieron cargar los datos.';
        this.isLoading = false;
      },
    });
  }

  toggleSection(section: string) {
    this.openSection = this.openSection === section ? null : section;
  }

  getPriorityClass(prioridad: string) {
    switch (prioridad?.toLowerCase()) {
      case 'alta':
        return 'prio-high';
      case 'media':
        return 'prio-medium';
      case 'baja':
        return 'prio-low';
      default:
        return '';
    }
  }

  getBadgeClass(estado: string) {
    if (!estado) return '';

    switch (estado.toLowerCase()) {
      case 'completada':
      case 'completado':
        return 'badge-ok';
      case 'en progreso':
        return 'badge-progress';
      case 'pendiente':
        return 'badge-pending';
      case 'vencida':
        return 'badge-expired';
      default:
        return 'badge-default';
    }
  }

  getIconByType(tipo: string): string {
    if (!tipo) return 'assets/svg/task-icon.svg';

    const map: Record<string, string> = {
      llamada: 'assets/svg/call-icon.svg',
      reunion: 'assets/svg/meeting-icon.svg',
      correo: 'assets/svg/email-icon.svg',
      seguimiento: 'assets/svg/folder-icon.svg',
      otro: 'assets/svg/task-icon.svg',
    };

    const key = tipo.trim().toLowerCase();
    return map[key] || map['otro'];
  }

  toggle(section: string) {
    if (section === 'day') this.showDayTasks = !this.showDayTasks;
    if (section === 'next') this.showNextTasks = !this.showNextTasks;
    if (section === 'late') this.showLateTasks = !this.showLateTasks;
  }

 loadNotifications(): void {
    this.isLoading = true;

    this.api.getMyNotifications().subscribe({
      next: (res: any) => {
        const notis = res.notificaciones || [];

        this.notifications = notis.map((n: any) => ({
          id: n.notificacion_id,
          tipo: this.mapTipo(n.tipo_notificacion),
          titulo: n.titulo,
          descripcion: n.descripcion,
          tiempo: this.getRelativeTime(n.fecha_creacion),
          leida: n.leida,
          accionUrl: n.accion_url,
        }));

        this.isLoading = false;
      },
      error: (err) => {
        console.error('Error cargando notificaciones', err);
        this.isLoading = false;
      },
    });
  }

  mapTipo(tipo: string) {
    switch (tipo) {
      case 'alerta': return 'alerta';
      case 'exito': return 'ok';
      case 'vencimiento': return 'alerta';
      case 'error': return 'error';
      default: return 'info';
    }
  }

  getRelativeTime(fechaISO: string): string {
    if (!fechaISO) return '';

    const fecha = new Date(fechaISO);
    const ahora = new Date();
    const diffMs = ahora.getTime() - fecha.getTime();

    const min = Math.floor(diffMs / (1000 * 60));
    const horas = Math.floor(diffMs / (1000 * 60 * 60));
    const dias = Math.floor(diffMs / (1000 * 60 * 60 * 24));

    if (min < 1) return 'justo ahora';
    if (min < 60) return `hace ${min} min`;
    if (horas < 24) return `hace ${horas} h`;
    if (dias === 1) return 'ayer';
    if (dias < 7) return `hace ${dias} días`;

    return fecha.toLocaleDateString('es-CL');
  }

  openMdlCreateOportunity(): void {
    this.dialog
      .open(MdlSelectCompanyType, {
        minWidth: '800px',
        maxHeight: '900px',
        panelClass: 'mat-dlg-class',
        data: {
          mode: 'create',
        },
      })
      .afterClosed()
      .subscribe((result) => {
        if (result && result.success) {
          this.cargarOportunidades();
        }
      });
  }

  openMdlCreateContract() {
    this.dialog
      .open(MdlmanageContract, {
        minWidth: '800px',
        maxHeight: '900px',
        panelClass: 'mat-dlg-class',
        data: {
          mode: 'create',
        },
      })
      .afterClosed()
      .subscribe((result) => {
        if (result && result.success) {
          this.cargarContratos();
        }
      });
  }

  openMdlNewTask(): void {
    this.dialog
      .open(MdlNewTaskComponent, {
        minWidth: '500px',
        maxHeight: '600px',
        panelClass: 'mat-dlg-class',
        data: {
          mode: 'crear',
        },
      })
      .afterClosed()
      .subscribe((result) => {
        if (result && result.success) {
          this.cargarTareasUsuario();
        }
      });
  }

  private esUUIDValido(id: string): boolean {
    const uuidRegex =
      /^[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
    return uuidRegex.test(id);
  }

  mostrarMensaje(
    mensaje: string,
    tipo: 'exito' | 'error' | 'advertencia'
  ): void {
    switch (tipo) {
      case 'exito':
        this.alertService.success('Éxito', mensaje);
        break;
      case 'error':
        this.alertService.error('Error', mensaje);
        break;
      case 'advertencia':
        this.alertService.warning('Advertencia', mensaje);
        break;
    }
  }

  verDetalleOportunidad(id: string, event?: MouseEvent): void {
    if (event) {
      const target = event.target as HTMLElement;
      const isCheckbox =
        target.tagName === 'INPUT' &&
        target.getAttribute('type') === 'checkbox';
      const isDropdown = target.closest('.dropdown-container') !== null;

      if (isCheckbox || isDropdown) {
        return;
      }
    }

    if (!id || !this.esUUIDValido(id)) {
      this.mostrarMensaje('ID de Oportunidad no valido', 'error');
      return;
    }

    this.router.navigate(['opportunity', id]).then((navigationResult) => {
      if (!navigationResult) {
        this.mostrarMensaje(
          'No se pudo cargar el detalle de la oportunidad',
          'error'
        );
        console.error('Error de navegacion a Oportunities', id);
      }
    });
  }

  verDetalleContrato(id: string, event?: MouseEvent): void {
    console.log('📦 ID recibido:', id);

    if (event) {
      const target = event.target as HTMLElement;
      const isCheckbox =
        target.tagName === 'INPUT' &&
        target.getAttribute('type') === 'checkbox';
      const isDropdown = target.closest('.dropdown-container') !== null;

      if (isCheckbox || isDropdown) {
        return;
      }
    }

    if (!id || !this.esUUIDValido(id)) {
      this.alertService.error('ID inválido', 'ID de contrato no válido');
      return;
    }

    this.router.navigate(['contracts', id]).then((navigationResult) => {
      if (!navigationResult) {
        this.alertService.error('Error de navegación', 'No se pudo cargar el detalle del contrato');
        console.error('Error de navegación a contract/', id);
      }
    });
  }

  verDetalleTarea(id: string, event?: MouseEvent): void {
    if (event) {
      const target = event.target as HTMLElement;
      const isCheckbox =
        target.tagName === 'INPUT' &&
        target.getAttribute('type') === 'checkbox';
      const isDropdown = target.closest('.dropdown-container') !== null;

      if (isCheckbox || isDropdown) {
        return;
      }
    }

    if (!id || !this.esUUIDValido(id)) {
      this.alertService.error('ID inválido', 'ID de tarea no válido');
      return;
    }

    this.router.navigate(['task', id]).then((navigationResult) => {
      if (!navigationResult) {
        this.alertService.error('Error de navegación', 'No se pudo cargar el detalle de la tarea');
        console.error('Error de navegación a task/', id);
      }
    });
  }

  verDetalleContacto(id: string, event?: MouseEvent): void {
    if (event) {
      const target = event.target as HTMLElement;
      const isCheckbox =
        target.tagName === 'INPUT' &&
        target.getAttribute('type') === 'checkbox';
      const isDropdown = target.closest('.dropdown-container') !== null;

      if (isCheckbox || isDropdown) {
        return;
      }
    }

    if (!id || !this.esUUIDValido(id)) {
      this.mostrarMensaje('ID de contacto no válido', 'error');
      return;
    }

    this.router.navigate(['contact', id]).then((navigationResult) => {
      if (!navigationResult) {
        this.mostrarMensaje(
          'No se pudo cargar el detalle del contacto',
          'error'
        );
        console.error('Error de navegación a contact/', id);
      }
    });
  }

  verDetalleCuenta(id: string, event?: MouseEvent): void {
    console.log('🆔 ID recibido en verDetalleCuenta:', id);

    if (event) {
      const target = event.target as HTMLElement;
      const isCheckbox =
        target.tagName === 'INPUT' &&
        target.getAttribute('type') === 'checkbox';
      const isDropdown = target.closest('.dropdown-container') !== null;

      if (isCheckbox || isDropdown) {
        return;
      }
    }

    if (!id || !this.esUUIDValido(id)) {
      this.mostrarMensaje('ID de cuenta no válido', 'error');
      return;
    }

    this.router.navigate(['account', id]).then((navigationResult) => {
      if (!navigationResult) {
        this.mostrarMensaje(
          'No se pudo cargar el detalle de la cuenta',
          'error'
        );
        console.error('Error de navegación a accounts/', id);
      }
    });
  }

  markNotificationAsRead(id: string): void {
    this.api.markNotificationAsRead(id).subscribe({
      next: () => {
        this.notifications = this.notifications.map((n) =>
          n.id === id ? { ...n, leida: true } : n
        );
      },
      error: (err) => console.error('Error marcando como leída', err),
    });
  }
  
  markAllNotificationsAsRead(): void {
    const ids = this.notifications.map((n) => n.id);
    ids.forEach((id) => {
      this.api.markNotificationAsRead(id).subscribe({
        error: (err) => console.error('Error marcando como leída', err),
      });
    });
  
    this.notifications = this.notifications.map((n) => ({ ...n, leida: true }));
  }
  

  goToNotification(n: any): void {
    this.markNotificationAsRead(n.id);
    if (n.accionUrl) {
      this.router.navigateByUrl(n.accionUrl);
    }
  }
  

}
